import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import defaultavatar from "../asset/defaultavatar.png";
import Swal from "sweetalert2";
import request from "./helpers/API";
import { Header } from "./header";
import axios from "axios";
import {
  Active,
  Approved,
  Inactive,
  KatamBanner,
  KatamProgressApplication,
  PektaBanner,
  PektaProgressApplication,
  PihtasBanner,
  PihtasProgressApplication,
  noBanner,
  noPekta,
} from "./helpers/profileBanner";
import { isUjianEnabledForAppType } from "./helpers/maintenanceSettings";
import {
  fetchSecureFileObjectUrl,
  resolveMediaFileId,
  revokeSecureFileUrl,
} from "./helpers/secureFileAccess";
import {
  useCountdownStore,
  useLoginStore,
  usePektaStore,
  useProfileStore,
} from "./helpers/state";

export function Profile() {
  var CryptoJS = require("crypto-js");
  const { profile, updateProfileField, resetProfile } = useProfileStore();
  const { login, updateLoginField, resetLoginNonAuth } = useLoginStore();
  const { setCountdown } = useCountdownStore();
  const [type, setType] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [loadProgress, setLoadProgress] = useState(0);
  const [status, setStatus] = useState(noPekta);
  const [approve, setApprove] = useState("Menunggu...");
  const [pihtasAppBanner, setPihtasBanner] = useState(noBanner);
  const [katamAppBanner, setKatamBanner] = useState(noBanner);
  const [pektaAppBanner, setPektaBanner] = useState(noBanner);
  const [appDate, setappDate] = useState("-");
  const [state, setState] = useState(true);
  const [katamactiveCheck, setKatamActive] = useState(Boolean(true));
  const [pihtasCreated, setpihtasCreated] = useState<string | undefined>();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [pektatestMark, settestMark] = useState<any>(
    "Sila Ambil Ujian Permohonan"
  );
  const [katamtestMark, setkatamtestMark] = useState<any>(
    "Sila Ambil Ujian Permohonan"
  );
  const [pihtastestMark, setpihtasTestmark] = useState<any>(
    "Sila Ambil Ujian Permohonan"
  );

  const PENDING_EXAM_LABEL = "Sila Ambil Ujian Permohonan";

  const getDisplayTestProgress = (
    appType: "PEKTA" | "KATAM" | "PIHTAS",
    testProgress: string
  ) => {
    if (
      testProgress === PENDING_EXAM_LABEL &&
      !isUjianEnabledForAppType(appType)
    ) {
      return "Menunggu...";
    }
    return testProgress;
  };

  const loadStartRef = useRef<number>(Date.now());
  const securePhotoUrlRef = useRef<string | null>(null);
  const MIN_LOADER_MS = 2000;

  useEffect(() => {
    return () => {
      revokeSecureFileUrl(securePhotoUrlRef.current);
      securePhotoUrlRef.current = null;
    };
  }, []);

  // Live-read helper to avoid stale closures in handlers and async callbacks
  const getLive = () => ({
    profile: useProfileStore.getState().profile,
    login: useLoginStore.getState().login,
  });

  let testMark = `Sila Ambil Ujian Permohonan`;
  let navigate = useNavigate();
  let location = useLocation();
  let expiredState: boolean = false;
  var userToken = useRef(null);

  // Helper function to pad Malaysian IC number to 12 digits with leading zeros
  const padICNumber = (icNumber: string | number | undefined | null): string => {
    if (!icNumber) return "";
    const icString = String(icNumber);
    // Pad with leading zeros to make it 12 digits
    return icString.padStart(12, "0");
  };

  // Log external referrer once; do not bump refreshTrigger here (that double-fetched files).
  useEffect(() => {
    const referrer = document.referrer;
    const isFromExternalSite =
      referrer && !referrer.includes(window.location.hostname);

    if (isFromExternalSite) {
      console.log("User came from external site, refreshing data");
    }
  }, []);

  let userID = login.id;
  let bytes = useRef(
    CryptoJS.AES.decrypt(login.jwtToken.toString(), `${process.env.SECRET_KEY}`)
  );
  userToken = useRef(bytes.current.toString(CryptoJS.enc.Utf8));

  interface PihtasApplication {
    createdAt: Date;
    updatedAt: Date;
    status: string;
    pekta_application_assessments: [];
  }

  // function isSessionExpired() {
  //   if (!login.lastVisited || null) {
  //     navigate("/login");
  //   } else {
  //     const currentTimestamp = Date.now();
  //     updateLoginField("lastVisited", currentTimestamp);
  //   }
  //
  //   const expiration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  //   const now = Date.now();
  //   return now - parseInt(login.lastVisited) > expiration;
  // }

  function testModal() {
    Swal.fire({
      showDenyButton: true,
      title: "Mula ujian?",
      text: `Ujian ini khas untuk permohonan ${type}`,
      icon: "question",
      confirmButtonText: "Terus",
      denyButtonText: "Batal",
      customClass: {
        confirmButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Set flag to indicate user came from profile
        sessionStorage.setItem("cameFromProfile", "true");

        if (type === "PEKTA") {
          navigate("/pekta-test");
        } else if (type === "KATAM") {
          navigate("/katam-test");
        } else if (type === "PIHTAS") {
          navigate("/pihtas-test");
        }
      } else {
        return "";
      }
    });
  }

  function katamAlert() {
    const { profile, login } = getLive();

    const currentKatam = profile.katam;
    if (currentKatam === "no") {
      Swal.fire("Tiada KATAM.");
    } else if (currentKatam === "processing") {
      Swal.fire("Permohonan KATAM dalam proses");
    } else if (currentKatam === "yes") {
      const isExpiredFromDates = moment(login.katamEnd, "YYYY/MM/DD").isAfter(
        moment(profile.pektaexpired, "YYYY/MM/DD")
      );
      if (isExpiredFromDates === true) {
        Swal.fire("KATAM telah tamat tempoh.");
      } else {
        sessionStorage.setItem("cameFromProfile", "true");
        navigate("/kad-tauliah-katam");
      }
    } else {
      Swal.fire("Tiada KATAM");
    }
  }

  // Loading progress animation: ramps to 90% while fetching, completes on finish
  useEffect(() => {
    let intervalId: any;
    let finishTimeoutId: any;

    if (isLoading) {
      setLoadProgress(0);
      intervalId = setInterval(() => {
        setLoadProgress((prev) => {
          if (prev >= 90) return prev;
          const increment = 5 + Math.random() * 8;
          return Math.min(prev + increment, 90);
        });
      }, 250);
    } else {
      setLoadProgress(100);
      finishTimeoutId = setTimeout(() => {
        setLoadProgress(0);
      }, 600);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (finishTimeoutId) clearTimeout(finishTimeoutId);
    };
  }, [isLoading]);

  const getCredentials = async (url: string): Promise<any> => {
    const response = await request({
      url,
      method: "GET",
      headers: { Authorization: `Bearer ${userToken.current}` },
    });

    return response;
  };

  useEffect(() => {
    try {
      resetLoginNonAuth();
    } catch (e) {}
    loadStartRef.current = Date.now();
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/pekta-setting`)
      .then((response: any) => {
        updateLoginField(
          "pekta_application_enable",
          response.data.data.attributes.pekta_application_enable
        );
        updateLoginField(
          "katam_application_enable",
          response.data.data.attributes.katam_application_enable
        );
        updateLoginField(
          "pihtas_application_enable",
          response.data.data.attributes.pihtas_application_enable
        );
        updateLoginField(
          "katamEnd",
          moment(response.data.data.attributes.katam_expiry_date).format(
            "YYYY/MM/DD"
          )
        );
        updateLoginField(
          "katamStart",
          moment(response.data.data.attributes.katam_start_date).format(
            "YYYY/MM/DD"
          )
        );
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        const elapsed = Date.now() - loadStartRef.current;
        const remaining = Math.max(0, MIN_LOADER_MS - elapsed);
        setTimeout(() => setIsLoading(false), remaining);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, resetLoginNonAuth, updateLoginField, refreshTrigger]);

  useEffect(() => {
    try {
      resetProfile();
    } catch (e) {}
    setIsLoading(true);
    getCredentials(
      `api/users/${userID}?populate[0]=profile_image&populate[1]=pekta&populate[2]=pekta.pekta_applications.photo_file&populate[3]=pekta.pekta_applications.pekta_application_assessments&populate[4]=pekta.pihtas_applications&populate[5]=pekta.pihtas_applications.pekta_application_assessments&populate[6]=pekta.katam_applications&populate[7]=pekta.katam_applications.pekta_application_assessments`
    )
      .then(async function (result) {
        // ==================================================Set Profile DATA===========================================
        updateProfileField("full_name", result.data.full_name);
        updateProfileField("phone_mobile", result.data.phone_mobile);

        // ==================================================Set Profile DATA===========================================

        let katamApp;
        let pihtasApp;
        let approvedDate;
        let appArray;
        let isPEKTAExpired = false;
        if (result.data.pekta) {
          katamApp = result.data.pekta.katam_applications;
          pihtasApp = result.data.pekta.pihtas_applications;
          const katamEndDate = moment(
            useLoginStore.getState().login.katamEnd,
            "YYYY/MM/DD",
            true
          );
          const expiryStr = moment(result.data.pekta.expiry_date).format(
            "YYYY/MM/DD"
          );
          const expiryDateMoment = moment(expiryStr, "YYYY/MM/DD", true);
          if (katamEndDate.isValid() && expiryDateMoment.isValid()) {
            isPEKTAExpired = katamEndDate.isAfter(expiryDateMoment);
          }
        }
        const latestKatamStatus = katamApp?.[katamApp.length - 1]?.status;
        const latestPihtasStatus = pihtasApp?.[pihtasApp.length - 1]?.status;
        if (!result.data.pekta && login.pekta_application_enable === true) {
          setPektaBanner(<PektaBanner />);
          updateLoginField("havePekta", "no");
          updateLoginField("pektaAppStatus", "none");
        } else if (result.data.pekta) {
          updateProfileField("profileRole", "PEKTA");
          updateProfileField(
            "registration_number",
            result.data.registration_number
          );
          updateLoginField("havePekta", "yes");
          updateLoginField(
            "pektaAppStatus",
            result.data.pekta?.pekta_applications[0]?.status
          );
          updateLoginField("pektaID", result.data.pekta.id);

          // updateProfileField(
          //   "expirydate",
          //   moment(result.data.pekta.expiry_date, "YYYY/MM/DD", true).toDate()
          // );
          updateProfileField(
            "pektaexpired",
            moment(result.data.pekta.expiry_date).format("YYYY/MM/DD")
          );
        }
        //  =========Set Aktif or Tak Aktif========================================================================
        if (
          result.data.pekta &&
          result.data.pekta?.pekta_applications[0]?.status === "approved"
        ) {
          const expiredDt = new Date(result.data.pekta.expiry_date);
          const userexpiry = moment(expiredDt).format("YYYY/MM/DD");
          setappDate(userexpiry);

          const katamEndDate = moment(
            useLoginStore.getState().login.katamEnd,
            "YYYY/MM/DD"
          );
          const expiryDate = moment(userexpiry, "YYYY/MM/DD");

          if (katamEndDate.isValid() && expiryDate.isValid()) {
            isPEKTAExpired = katamEndDate.isAfter(expiryDate);
            updateProfileField("isExpired", isPEKTAExpired);
          }

          setKatamActive(expiryDate.isSameOrAfter(katamEndDate));

          const latestKatamApp =
            result.data.pekta.katam_applications[
              result.data.pekta.katam_applications.length - 1
            ];

          const isKatamValid =
            latestKatamApp &&
            latestKatamApp.status === "approved" &&
            moment(userexpiry, "YYYY/MM/DD").isSame(
              moment(useLoginStore.getState().login.katamEnd, "YYYY/MM/DD")
            );

          setStatus(
            <Approved
              role={result.data.pekta ? "PEKTA" : "TIADA"}
              activation={isKatamValid ? <Active /> : <Inactive />}
              pektaID={result.data.registration_number}
              katamAlert={katamAlert}
              status={katamactiveCheck}
            />
          );
        } else {
          setStatus(noBanner);
        }

        // ==================================================CHECK PIHTAS STATUS===========================================

        if (
          result.data.pekta &&
          result.data.pekta.pihtas_applications &&
          result.data.pekta.pihtas_applications.length > 0
        ) {
          const sortedApplications = result.data.pekta.pihtas_applications
            .slice()
            .sort(
              (a: PihtasApplication, b: PihtasApplication) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            );
          const latestPihtasApplication = sortedApplications[0];
          setpihtasCreated(
            moment(new Date(latestPihtasApplication.createdAt)).format(
              "YYYY/MM/DD"
            )
          );

          if (
            latestPihtasApplication !== "rejected" &&
            katamApp[katamApp.length - 1]?.status === "approved"
          ) {
            const approveDt = new Date(latestPihtasApplication?.updatedAt);
            approvedDate = moment(approveDt).format("DD/MM/YYYY");
            updateProfileField("saringanPihtas", approvedDate);

            setType("PIHTAS");

            if (latestPihtasApplication?.status === "processing") {
              setCountdown(45 * 60);
              if (
                latestPihtasApplication.pekta_application_assessments.length !==
                0
              ) {
                let testQuestion =
                  latestPihtasApplication.pekta_application_assessments[0]
                    .question_count;
                let correctCount =
                  latestPihtasApplication.pekta_application_assessments[0]
                    .question_correct_count;

                if (
                  latestPihtasApplication.pekta_application_assessments[0]
                    .is_pass === true
                ) {
                  testMark = `Lulus: ${correctCount}/${testQuestion}`;
                  setpihtasTestmark(testMark);
                  setState(true);
                } else {
                  testMark = `Gagal: ${correctCount}/${testQuestion}`;
                  setpihtasTestmark(testMark);
                  setApprove("Tidak Layak");
                  setState(true);
                }
              } else {
                setState(false);
              }
              setType("PIHTAS");
            }
          }
        }
        // if user got katam application
        if (result.data.pekta && !katamApp) {
          updateProfileField("katam", "no");
        }

        // ==================================================CHECK KATAM STATUS===========================================

        if (result.data.pekta && katamApp.length !== 0) {
          const latestApplication = katamApp[katamApp.length - 1];
          const approveDt = new Date(latestApplication?.updatedAt);
          const approvedDate = moment(approveDt).format("DD/MM/YYYY");
          updateProfileField("saringanKatam", approvedDate);

          if (
            latestApplication.status === "pending" ||
            latestApplication.status === "interview"
          ) {
            updateProfileField("katam", "processing");
          } else if (latestApplication.status === "processing") {
            setCountdown(45 * 60);
            let testResult = latestApplication.pekta_application_assessments;

            if (testResult.length !== 0) {
              let testQuestion =
                katamApp[result.data.pekta.katam_applications.length - 1]
                  .pekta_application_assessments[0].question_count;
              let correctCount =
                katamApp[result.data.pekta.katam_applications.length - 1]
                  .pekta_application_assessments[0].question_correct_count;

              if (
                katamApp[result.data.pekta.katam_applications.length - 1]
                  .pekta_application_assessments[0].is_pass === true
              ) {
                testMark = `Lulus: ${correctCount}/${testQuestion}`;
                setkatamtestMark(testMark);
                setState(true);
              } else {
                testMark = `Gagal: ${correctCount}/${testQuestion}`;
                setkatamtestMark(testMark);
                setApprove("Tidak Layak");
                setState(true);
              }
            } else {
              setState(Boolean(false));
            }
            setType("KATAM");
            updateProfileField("katam", "processing");
          } else if (
            latestApplication.status === "approved" &&
            isPEKTAExpired == false
          ) {
            updateProfileField("katam", "yes");
          } else {
            updateProfileField("katam", "no");
          }
        }

        // ==================================================CHECK PEKTA STATUS===========================================

        if (result.data.pekta && result.data.pekta?.pekta_applications) {
          appArray = result.data.pekta?.pekta_applications;
          const approveDt = new Date(appArray[0]?.updatedAt);
          approvedDate = moment(approveDt).format("DD/MM/YYYY");
          updateProfileField("saringanPekta", approvedDate);

          if (result.data.pekta?.pekta_applications[0]?.status === "approved") {
          } else if (
            result.data.pekta?.pekta_applications[0]?.status === "processing"
          ) {
            let testResult = appArray[0].pekta_application_assessments;

            if (testResult.length !== 0) {
              let testQuestion =
                appArray[0].pekta_application_assessments[0].question_count;
              let correctCount =
                appArray[0].pekta_application_assessments[0]
                  .question_correct_count;

              if (
                appArray[0].pekta_application_assessments[0].is_pass === true
              ) {
                settestMark(`Lulus: ${correctCount}/${testQuestion}`);
                setState(Boolean(true));
              } else {
                settestMark(`Gagal: ${correctCount}/${testQuestion}`);
                setApprove("Tidak Layak");
                setState(Boolean(true));
              }
            } else {
              setState(Boolean(false));
            }
            setType("PEKTA");
          } else if (
            result.data.pekta?.pekta_applications[0]?.status === "pending" ||
            result.data.pekta?.pekta_applications[0]?.status === "rejected" ||
            result.data.pekta?.pekta_applications[0]?.status === "interview"
          ) {
            // setStatus(noBanner)
          }
        }

        // =============================Banner=================================

        // Get fresh login state to avoid stale closure
        const currentLoginState = useLoginStore.getState().login;
        const currentProfileState = useProfileStore.getState().profile;

        //Pekta banner
        if (
          (!result.data.pekta &&
            currentLoginState.pekta_application_enable === true) ||
          (result.data.pekta &&
            result.data.pekta?.pekta_applications[0]?.status === "rejected" &&
            currentLoginState.pekta_application_enable === true)
        ) {
          setPektaBanner(<PektaBanner />);
        }

        //Katam banner
        if (
          result.data.pekta &&
          result.data.pekta?.pekta_applications[0]?.status === "approved"
        ) {
          if (katamApp.length === 0) {
            if (currentLoginState.katam_application_enable === true)
              setKatamBanner(
                <KatamBanner katamExist={profile.katam} expiredState={true} />
              );
          } else {
            if (
              katamApp[katamApp.length - 1]?.status === "pending" ||
              katamApp[katamApp.length - 1]?.status === "processing" ||
              katamApp[katamApp.length - 1]?.status === "interview"
            ) {
              setPektaBanner(noBanner);
              setKatamBanner(noBanner);
            } else if (
              katamApp[katamApp.length - 1].status === "rejected" &&
              isPEKTAExpired === true
            ) {
              setKatamBanner(
                <KatamBanner katamExist={profile.katam} expiredState={true} />
              );
            } else if (
              katamApp[katamApp.length - 1]?.status === "approved" &&
              isPEKTAExpired === false
            ) {
              setKatamBanner(noBanner);
            } else if (
              katamApp[katamApp.length - 1].status === "approved" &&
              isPEKTAExpired === true &&
              currentLoginState.katam_application_enable === true
            ) {
              setKatamBanner(
                <KatamBanner katamExist={profile.katam} expiredState={true} />
              );
            }
          }

          const latestPihtasCreated = pihtasCreated
            ? pihtasCreated
            : moment(currentProfileState?.pihtasApp?.createdAt).format(
                "YYYY/MM/DD"
              );

          if (
            currentLoginState.pihtas_application_enable &&
            latestKatamStatus === "approved" &&
            isPEKTAExpired === false
          ) {
            if (!pihtasApp.length) {
              setPihtasBanner(<PihtasBanner />);
            } else if (
              ["pending", "processing", "interview"].includes(
                latestPihtasStatus
              )
            ) {
              setPihtasBanner(noBanner);
            } else if (
              latestPihtasStatus === "rejected" ||
              (latestKatamStatus === "approved" &&
                moment(latestPihtasCreated).isBefore(
                  moment(currentLoginState.katamStart)
                ))
            ) {
              setPihtasBanner(<PihtasBanner />);
            }
          } else {
            setPihtasBanner(noBanner);
          }
        }

        // =============================Banner=================================

        if (result?.data?.pekta?.pekta_applications) {
          // PEKTA
          updateProfileField(
            "pektaApp",
            result.data.pekta?.pekta_applications[0]
          );
          // KATAM
          if (
            result.data.pekta.katam_applications &&
            result.data.pekta.katam_applications.length > 0
          ) {
            updateProfileField(
              "katamApp",
              result.data.pekta.katam_applications[
                result.data.pekta.katam_applications.length - 1
              ]
            );
          }

          // PIHTAS
          if (
            result.data.pekta.pihtas_applications &&
            result.data.pekta.pihtas_applications.length > 0
          ) {
            updateProfileField(
              "pihtasApp",
              result.data.pekta.pihtas_applications[
                result.data.pekta.pihtas_applications.length - 1
              ]
            );
          }
        }
        const defaultPhotoURL = defaultavatar;

        const pektaApplication = result?.data?.pekta?.pekta_applications[0];
        const nric = pektaApplication?.nric;
        const photoFileId = resolveMediaFileId(
          pektaApplication?.photo_file,
          result.data.profile_image
        );

        if (!nric) {
          updateProfileField("id_no", padICNumber(result.data.id_no));
        } else {
          updateProfileField("id_no", padICNumber(nric));
        }

        revokeSecureFileUrl(securePhotoUrlRef.current);
        securePhotoUrlRef.current = null;

        let photoURL = defaultPhotoURL;
        if (photoFileId) {
          try {
            const secureUrl = await fetchSecureFileObjectUrl(
              photoFileId,
              userToken.current
            );
            if (secureUrl) {
              photoURL = secureUrl;
              securePhotoUrlRef.current = secureUrl;
            }
          } catch (error) {
            console.error("Failed to load profile photo via secure API:", error);
          }
        }

        updateProfileField("gambar", photoURL);
      })
      .then(() => {
        //         if (isSessionExpired()) {
        //           Swal.fire({
        //             allowOutsideClick: false,
        //             title: "Log Masuk Semula",
        //             text: `Sesi log masuk sudah tamat, sila log masuk semula.`,
        //             icon: "question",
        //             confirmButtonText: "Terus",
        //             customClass: {
        //               confirmButton: "order-3",
        //             },
        //           }).then((result) => {
        //             if (result.isConfirmed) {
        //               window.localStorage.clear();
        //               window.location.href = "/login";
        //             }
        //           });
        //         }
      })
      .finally(() => {
        const elapsed = Date.now() - loadStartRef.current;
        const remaining = Math.max(0, MIN_LOADER_MS - elapsed);
        setTimeout(() => setIsLoading(false), remaining);
      });
  }, [
    userID,
    resetProfile,
    updateProfileField,
    updateLoginField,
    refreshTrigger,
    login.katam_application_enable,
    login.pekta_application_enable,
    login.pihtas_application_enable,
  ]);

  return (
    <>
      <Header />
      {isLoading ? (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
          <div className="flex flex-col items-center gap-8 p-8 py-12 bg-white rounded-xl shadow-lg w-96 min-h-[320px]">
            <div className="relative h-24 w-24">
              <div className="absolute inset-0 rounded-full border-4 border-gray-200"></div>
              <div className="absolute inset-0 rounded-full border-4 border-lime-600 border-t-transparent animate-spin"></div>
              <div className="absolute inset-2 rounded-full bg-white"></div>
            </div>
            <div className="w-full">
              <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-lime-600 transition-all duration-200"
                  style={{ width: `${Math.round(loadProgress)}%` }}
                />
              </div>
              <div className="mt-3 text-center text-base text-gray-700">
                Memuatkan data... {Math.round(loadProgress)}%
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center justify-center min-h-screen py-2 bg-gray-100">
          <main className="flex flex-col items-center justify-center lg:w-1/3 md:w-3/5 mx-20 flex-1 text-center">
            {status}
            {login.pihtas_application_enable && pihtasAppBanner}
            {login.katam_application_enable && katamAppBanner}
            {login.pekta_application_enable && pektaAppBanner}
            <div className="bg-white rounded-md shadow-2xl flex  flex-col lg:w-1/3  md:w-3/5  px-8 mb-4 justify-center items-center  ">
              <div className="mt-8 w-72">
                <img src={profile.gambar} alt="default"></img>
              </div>
              <br />
              <p className="text-sm mt-8 text-gray-400 font-medium">NAMA</p>
              <p>{profile.full_name}</p>
              <p className="text-sm mt-3 text-gray-400 font-medium">EMEL</p>
              <p>{login.email}</p>
              <p className="text-sm mt-3 text-gray-400 font-medium">
                NO. KAD PENGENALAN
              </p>
              <p>{profile.id_no}</p>
              <p className="text-sm mt-3 text-gray-400 font-medium">
                NO. TELEFON
              </p>
              <p className="mb-6">{profile.phone_mobile}</p>
              <div>
                <button
                  hidden={state || !isUjianEnabledForAppType(type)}
                  onClick={testModal}
                  className="bg-lime-700 text-white rounded-md p-2 text-base h-11 w-32 mb-3"
                >
                  Ambil Ujian
                </button>
              </div>
            </div>
            {
              <PektaProgressApplication
                appRole={"PEKTA"}
                processed={!profile.pektaApp ? "-" : profile.pektaApp.status}
                screening={profile.saringanPekta}
                approve={approve}
                testProgress={getDisplayTestProgress("PEKTA", pektatestMark)}
                ulasan={profile.pektaApp?.ulasan}
              />
            }
            {
              <KatamProgressApplication
                appRole={"KATAM"}
                processed={!profile.katamApp ? "-" : profile.katamApp.status}
                screening={profile.saringanKatam}
                approve={approve}
                testProgress={getDisplayTestProgress("KATAM", katamtestMark)}
                //expiry={profile.expirydate}
                expiry={profile.isExpired}
                katamEnd={login.katamEnd}
                katamEnable={login.katam_application_enable}
                ulasan={profile.katamApp?.ulasan}
              />
            }
            {
              <PihtasProgressApplication
                appRole={"PIHTAS"}
                processed={!profile.pihtasApp ? "-" : profile.pihtasApp.status}
                screening={profile.saringanPihtas}
                approve={approve}
                testProgress={getDisplayTestProgress("PIHTAS", pihtastestMark)}
                expiry={appDate}
                katamEnd={login.katamEnd}
                katamStart={login.katamStart}
                created={pihtasCreated}
                ulasan={profile.pihtasApp?.ulasan}
              />
            }
          </main>
        </div>
      )}
    </>
  );
}
